import Config from "../../core/config";
import axios from "axios";

export function checkWidgets(widgetList) {
    for (let x in widgetList) {
        let w = widgetList[x];
        if (w.selector) {
            let element = document.querySelector(w.selector);
            if (element || 1) {
                if (Config.acmsWidgetScript) {
                    element = document.getElementsByTagName("body")[0];
                    var newScript = document.createElement("script");
                    newScript.src = Config.acmsWidgetScript;
                    element.appendChild(newScript);
                }
                return true;
            } else {
                console.log("did not find element:", w.selector);
            }
        }
    }
    return false;
}

export function checkScripts() {
    let shouldLoadFullApplication = null;
    let appElement = document.getElementById("application");

    if (appElement) {
        shouldLoadFullApplication = appElement.getAttribute("data-renderer") !== "loader" ? appElement.getAttribute("data-renderer") : false;
    }

    if (shouldLoadFullApplication) {
        if (Config.acmsFullScript) {
            let element = document.getElementsByTagName("body")[0];
            var newScript = document.createElement("script");

            newScript.src = Config.acmsFullScript;
            element.appendChild(newScript);
        }
    } else {
        let widgetListUrl = Config.api.getWidgetUrl(Config.language) +  window.document.location.pathname + window.document.location.search;

        axios.get(widgetListUrl, Config.getApiConfig()).then(response => {
            checkWidgets(response.data);
        });
    }
}

export function loadScripts() {
    setTimeout(function () {
        checkScripts()
    }, 1000);
}


// WEBPACK FOOTER //
// ./src/loader/helpers/loaderHelpers.js